import api from './axiosInstance';

export const authApi = {
  register: data => api.post('/auth/register', data),
  requestOtp: data => api.post('/auth/otp/request', data),
  verifyOtp: data => api.post('/auth/otp/verify', data),
  refreshToken: data => api.post('/auth/refresh', data),
  logout: data => api.post('/auth/logout', data),
  getMe: () => api.get('/auth/me'),
  updateProfile: data => api.put('/auth/me', data),
  deleteAccount: () => api.post('/account/delete'),
};
